exports = module.exports = require("../../../../vue-ssr-factory/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".market-contact-text-span[data-v-2af8b771]:hover {\n  color: #00a4ff;\n}\n", ""]);

